var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSignBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#4B9BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75537 15H11.1328V8.10645H9.75537V15ZM10.4473 7.12256C10.8916 7.12256 11.2534 6.76709 11.2534 6.3291C11.2534 5.87842 10.8916 5.53564 10.4473 5.53564C10.0029 5.53564 9.64111 5.87842 9.64111 6.3291C9.64111 6.76709 10.0029 7.12256 10.4473 7.12256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSignBlue);
export default __webpack_public_path__ + "static/media/info-sign-blue.df2a208aa5355dd9f71b7fb17275a70a.svg";
export { ForwardRef as ReactComponent };